import { useEffect, useState } from 'react';
import { Modal, Input, Switch, message } from 'antd';
import * as claus from 'src/_shared/services/claus/endpoints';

// Duplicate an integration within the same company (CLAUS duplicate is same-customer only). The copy
// starts disabled; credentials are copied only if requested.
export default function DuplicateIntegrationDialog({ orgId, integration, onClose, onDuplicated }) {
	const [name, setName] = useState('');
	const [copyCredentials, setCopyCredentials] = useState(false);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		if (integration) {
			setName(`${integration.name} (copy)`);
			setCopyCredentials(false);
		}
	}, [integration]);

	async function duplicate() {
		if (!integration) return;
		setSaving(true);
		try {
			await claus.duplicateIntegration(orgId, integration.id, {
				targetOrganizationId: orgId,
				name: name.trim() || undefined,
				copyCredentials,
			});
			message.success('Integration duplicated (starts disabled)');
			await onDuplicated();
		} catch (e) {
			message.error(e.message || 'Could not duplicate the integration.');
		} finally {
			setSaving(false);
		}
	}

	return (
		<Modal
			title={integration ? `Duplicate ${integration.name}` : 'Duplicate'}
			open={!!integration}
			onCancel={onClose}
			onOk={duplicate}
			okText="Duplicate"
			confirmLoading={saving}
			wrapClassName="erin-integrations"
		>
			<div className="ei-field">
				<label className="ei-field-label">New integration name</label>
				<Input value={name} onChange={(e) => setName(e.target.value)} />
			</div>
			<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
				<Switch checked={copyCredentials} onChange={setCopyCredentials} />
				<span className="js-muted">Copy credentials into the duplicate</span>
			</div>
		</Modal>
	);
}
